import jsonp from '@/common/jsonp.js'
import axios from '@/common/axios.js'
import {jsonpCommonOption, axiosCommonOption, ajaxUrl,qqMapKey} from '@/common/config'

class DataRequestFactory {
  /**
   * 获取微信JSSDK签名
   * @returns {*}
   */
  static getWeixinJSSDKConfig (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/APP101010.ashx', data, jsonpCommonOption)
  }
  /**
   * 取手机菜单
   * @param params
   */
  static I010010 () {
    return jsonp(ajaxUrl + '/Ashx/I010010.ashx', null, jsonpCommonOption)
  }
  /**
   * 学员绑定_初始化页面
   * @param params
   */
  static I020010 () {
    return jsonp(ajaxUrl + '/Ashx/I020010.ashx', null, jsonpCommonOption)
  }
  /**
   * 学员绑定_保存
   * @param params
   */
  static I020011 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I020011.ashx', data, jsonpCommonOption)
  }
  /**
   * 个人信息(家长)_初始化
   * @param params
   */
  static I030010 () {
    return jsonp(ajaxUrl + '/Ashx/I030010.ashx', null, jsonpCommonOption)
  }
  /**
   * 个人信息(家长)_保存
   * @param params
   */
  static I030011 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I030011.ashx', data, jsonpCommonOption)
  }
  /**
   * 最新活动
   * @param params
   */
  static I040010 () {
    return jsonp(ajaxUrl + '/Ashx/I040010.ashx', null, jsonpCommonOption)
  }
  /**
   * 精彩活动
   * @param params
   */
  static I040020 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I040020.ashx', data, jsonpCommonOption)
  }
  /**
   * 活动详情
   * @param params
   */
  static I040030 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I040030.ashx', data, jsonpCommonOption)
  }
  /**
   * 活动详细_提交
   * @param params
   */
  static I040031 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I040031.ashx', data, jsonpCommonOption)
  }
  /**
   * 拓展阅读_初始化
   * @param params
   */
  static I050010 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I050010.ashx', data, jsonpCommonOption)
  }
  /**
   * 拓展阅读-导读_初始化
   * @param params
   */
  static I050020 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I050020.ashx', data, jsonpCommonOption)
  }
  /**
   * 拓展阅读-分页_初始化
   * @param params
   */
  static I050030 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I050030.ashx', data, jsonpCommonOption)
  }
  /**
   * 拓展阅读-测试_初始化
   * @param params
   */
  static I050040 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I050040.ashx', data, jsonpCommonOption)
  }
  /**
   * 拓展阅读-测试_提交
   * @param params
   */
  static I050041 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I050041.ashx', data, jsonpCommonOption)
  }
  /**
   * 拓展阅读-测试_提交
   * @param params
   */
  static I050050 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I050050.ashx', data, jsonpCommonOption)
  }
  /**
   * 课程资料_列表
   * @param params
   */
  static I060010 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I060010.ashx', data, jsonpCommonOption)
  }
  /**
   * 课程资料_详细
   * @param params
   */
  static I060020 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I060020.ashx', data, jsonpCommonOption)
  }
  /**
   * 老师回访_初始化
   * @param params
   */
  static I200010 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I200010.ashx', data, jsonpCommonOption)
  }
  /**
   * 老师回访详细_初始化
   * @param params
   */
  static I200020 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I200020.ashx', data, jsonpCommonOption)
  }
  /**
   * 老师回访详细_初始化
   * @param params
   */
  static I20002X (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I20002X.ashx', data, jsonpCommonOption)
  }
  /**
   * 老师回访详细_保存
   * @param params
   */
  static I200021 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I200021.ashx', data, jsonpCommonOption)
  }
  /**
   * 学管回访_初始化
   * @param params
   */
  static I200030 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I200030.ashx', data, jsonpCommonOption)
  }
  /**
   * 学管回访详细_初始化
   * @param params
   */
  static I200040 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I200040.ashx', data, jsonpCommonOption)
  }
  /**
   * 学管回访详细_保存
   * @param params
   */
  static I200041 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I200041.ashx', data, jsonpCommonOption)
  }
  /**
   * 顾问回访_初始化
   * @param params
   */
  static I200050 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I200050.ashx', data, jsonpCommonOption)
  }
  /**
   * 顾问回访详细_初始化
   * @param params
   */
  static I200060 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I200060.ashx', data, jsonpCommonOption)
  }
  /**
   * 顾问回访详细_保存
   * @param params
   */
  static I200061 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I200061.ashx', data, jsonpCommonOption)
  }
  /**
   * 学员二维码_查询
   * @param params
   */
  static I300010 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I300010.ashx', data, jsonpCommonOption)
  }
  /**
   * 学员二维码_详细
   * @param params
   */
  static I300020 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I300020.ashx', data, jsonpCommonOption)
  }
  /**
   * 活动签到码_取活动主题
   * @param params
   */
  static I300030 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I300030.ashx', data, jsonpCommonOption)
  }
  /**
   * 活动签到码_生成签到二维码
   * @param params
   */
  static I300031 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I300031.ashx', data, jsonpCommonOption)
  }
  /**
   * 拓展阅读搜索/筛选
   * @param params
   */
  static I050011 () {
    return jsonp(ajaxUrl + '/Ashx/I050011.ashx', null, jsonpCommonOption)
  }
  /**
   * 电影院初期化
   * @param params
   */
  static I400010 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I400010.ashx', data, jsonpCommonOption)
  }
  /**
   * 电影院详细 初始化页面
   * @param params
   */
  static I400020 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I400020.ashx', data, jsonpCommonOption)
  }
  /**
   * 电影院详细 点赞/取消点赞
   * @param params
   */
  static I400021 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I400021.ashx', data, jsonpCommonOption)
  }
  /**
   * 音乐厅初期化
   * @param params
   */
  static I400030 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I400030.ashx', data, jsonpCommonOption)
  }
  /**
   * 音乐厅详细 初期化
   * @param params
   */
  static I400040 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I400040.ashx', data, jsonpCommonOption)
  }
  /**
   * 音乐厅详细 点赞/取消点赞
   * @param params
   */
  static I400041 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I400041.ashx', data, jsonpCommonOption)
  }
  /**
   * 录播回放(新）（一级目录）
   * @param params
   */
  static I4000601 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I4000601.ashx', data, jsonpCommonOption)
  }
  /**
   * 录播回放(新）(二级目录)
   * @param params
   */
  static I4000611 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I4000611.ashx', data, jsonpCommonOption)
  }
  /**
   * 录播回放列表(新)
   * @param params
   */
  static I4000621 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I4000621.ashx', data, jsonpCommonOption)
  }
  /**
   * 录播回放（新）初期化
   * @param params
   */
  static I4000631 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I4000631.ashx', data, jsonpCommonOption)
  }
  /**
   * 录播回放详细（新） 点赞/取消点赞
   * @param params
   */
  static I4000632 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I4000632.ashx', data, jsonpCommonOption)
  }
  /**
   * 推荐文章
   * @param params
   */
  static I070010 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I070010.ashx', data, jsonpCommonOption)
  }
  /**
   * 共通_取校区列表
   * @param params
   */
  static C010010 () {
    return jsonp(ajaxUrl + '/Ashx/C010010.ashx', null, jsonpCommonOption)
  }
  /**
   * 共通_取班级列表
   * @param params
   */
  static C010011 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/C010011.ashx', data, jsonpCommonOption)
  }
  /**
   * 获取验证码
   * @param params
   */
  static C020010 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/C020010.ashx', data, jsonpCommonOption)
  }
  /**
   * 点读课本_初始化页面
   * @param params
   */
  static I110010 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I110010.ashx', data, jsonpCommonOption)
  }
  /**
   * 点读课本_初始化页面
   * @param params
   */
  static C110010 () {
    return jsonp(ajaxUrl + '/Ashx/C110010.ashx', null, jsonpCommonOption)
  }
  /**
   * 课本目录_初始化页面
   * @param params
   */
  static I110020 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I110020.ashx', data, jsonpCommonOption)
  }
  /**
   * 配音分享_初始化页面
   * @param params
   */
  static I120020 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I120020.ashx', data, jsonpCommonOption)
  }
  /**
   * 销售业绩
   * @param params
   */
  static I500010 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I500010.ashx', data, jsonpCommonOption)
  }

  /**
   * 阅读排名
   * @param params
   */
  static I500020 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I500020.ashx', data, jsonpCommonOption)
  }

  /**
   * 校长回访一览页面初期化
   * @param params
   */
  static I600010 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I600010.ashx', data, jsonpCommonOption)
  }

  /**
   * 校长回访详细页面初期化
   * @param params
   */
  static I600020 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I600020.ashx', data, jsonpCommonOption)
  }

  /**
   * 校长回访详细_保存
   * @param params
   */
  static I600021 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I600021.ashx', data, jsonpCommonOption)
  }

  /**
   * 取学员列表
   * @param params
   */
  static C010012 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/C010012.ashx', data, jsonpCommonOption)
  }

  /**
   * 校长听评课一览页面初期化
   * @param params
   */
  static I600030 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I600030.ashx', data, jsonpCommonOption)
  }

  /**
   * 拓展阅读-测试_初始化/上一题/下一题
   * @param params
   */
  static I050042 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I050042.ashx', data, jsonpCommonOption)
  }

  /**
   * 拓展阅读-测试_提交答案
   * @param params
   */
  static I050043 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I050043.ashx', data, jsonpCommonOption)
  }

  /**
   * 拓展阅读-测试_问题/答案详细
   * @param params
   */
  static I050044 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I050044.ashx', data, jsonpCommonOption)
  }

  /**
   * 校长听评课详细_保存
   * @param params
   */
  static I600041 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I600041.ashx', data, jsonpCommonOption)
  }

  /**
   * 校长听评课详细
   * @param params
   */
  static I600040 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I600040.ashx', data, jsonpCommonOption)
  }

  /**
   * 课时余额查询_初期化页面
   * @param params
   */
  static I700010 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I700010.ashx', data, jsonpCommonOption)
  }

  /**
   * 课时余额查询_发送验证码
   * @param params
   */
  static I700011 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I700011.ashx', data, jsonpCommonOption)
  }

  /**
   * 课时余额查询_查询
   * @param params
   */
  static I700012 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I700012.ashx', data, jsonpCommonOption)
  }

  /**
   * 课时余额查询详细_初期化页面
   * @param params
   */
  static I700020 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I700020.ashx', data, jsonpCommonOption)
  }

  /**
   * 获取校区
   * @param params
   */
  static I800010 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I800010.ashx', data, jsonpCommonOption)
  }

  /**
   * 发送验证码
   * @param params
   */
  static I800011 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I800011.ashx', data, jsonpCommonOption)
  }

  /**
   * 登录
   * @param params
   */
  static I800012 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I800012.ashx', data, jsonpCommonOption)
  }

  /**
   * 课时余额查询详细_初期化页面
   * @param params
   */
  static I800020 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I800020.ashx', data, jsonpCommonOption)
  }

  /**
   * 生成未签名 PDF
   * @param params
   */
  static I800021 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I800021.ashx', data, jsonpCommonOption)
  }

  /**
   * 上传签名
   * @param params
   */
  static I800030 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I800030.ashx', data, jsonpCommonOption)
  }

  /**
   * 生成签名PDF
   * @param params
   */
  static I800031 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I800031.ashx', data, jsonpCommonOption)
  }

  /**
   * 获得PDF
   * @param params
   */
  static I800040 (params) {
    let data = {
      JSON: JSON.stringify(params)
    }
    return jsonp(ajaxUrl + '/Ashx/I800040.ashx', data, jsonpCommonOption)
  }
}
export default DataRequestFactory



// WEBPACK FOOTER //
// ./src/factories/dataRequestFactory.js